/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LoginInput = {
    email: string;
    password: string;
};
export type Register_login_MutationVariables = {
    input: LoginInput;
};
export type Register_login_MutationResponse = {
    readonly login: {
        readonly token: string;
    } | null;
};
export type Register_login_Mutation = {
    readonly response: Register_login_MutationResponse;
    readonly variables: Register_login_MutationVariables;
};



/*
mutation Register_login_Mutation(
  $input: LoginInput!
) {
  login(input: $input) {
    token
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LoginPayload",
    "kind": "LinkedField",
    "name": "login",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Register_login_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Register_login_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d2d98a165331378cca7e8fd2efb4e9d2",
    "id": null,
    "metadata": {},
    "name": "Register_login_Mutation",
    "operationKind": "mutation",
    "text": "mutation Register_login_Mutation(\n  $input: LoginInput!\n) {\n  login(input: $input) {\n    token\n  }\n}\n"
  }
};
})();
(node as any).hash = '7143351e6ee9e498fa3540ad4e2c1585';
export default node;
